// Bulgarian to English food name translations for USDA API search
const bgToEnFoodMap = {
  // Плодове / Fruits
  "ябълка": "apple", "ябълки": "apple", "банан": "banana", "банани": "banana",
  "портокал": "orange", "портокали": "orange", "грозде": "grape", "грозд": "grape",
  "ягода": "strawberry", "ягоди": "strawberry", "малина": "raspberry", "малини": "raspberry",
  "круша": "pear", "круши": "pear", "праскова": "peach", "праскови": "peach",
  "кайсия": "apricot", "кайсии": "apricot", "слива": "plum", "сливи": "plum",
  "череша": "cherry", "череши": "cherry", "вишна": "sour cherry", "вишни": "sour cherry",
  "диня": "watermelon", "пъпеш": "melon", "киви": "kiwi", "манго": "mango",
  "ананас": "pineapple", "лимон": "lemon", "лимони": "lemon", "грейпфрут": "grapefruit",
  "мандарина": "tangerine", "мандарини": "tangerine", "смокиня": "fig", "смокини": "fig",
  "авокадо": "avocado", "нар": "pomegranate", "боровинка": "blueberry", "боровинки": "blueberry",
  "касис": "black currant",

  // Зеленчуци / Vegetables
  "домат": "tomato", "домати": "tomato", "краставица": "cucumber", "краставици": "cucumber",
  "морков": "carrot", "моркови": "carrot", "картоф": "potato", "картофи": "potato",
  "лук": "onion", "чесън": "garlic", "пипер": "pepper", "пиперка": "pepper",
  "чушка": "bell pepper", "чушки": "bell pepper", "тиквичка": "zucchini", "тиквички": "zucchini",
  "патладжан": "eggplant", "патладжани": "eggplant", "броколи": "broccoli",
  "карфиол": "cauliflower", "зеле": "cabbage", "спанак": "spinach",
  "маруля": "lettuce", "салата": "lettuce", "целина": "celery",
  "ряпа": "turnip", "цвекло": "beet", "тиква": "pumpkin", "гъби": "mushroom",
  "гъба": "mushroom", "зелен фасул": "green beans", "грах": "peas",
  "царевица": "corn", "аспержи": "asparagus", "репичка": "radish",
  "маслина": "olive", "маслини": "olive", "рукола": "arugula",

  // Месо / Meat
  "пиле": "chicken", "пилешко": "chicken", "пилешки": "chicken",
  "пилешко месо": "chicken meat", "пилешко филе": "chicken breast",
  "пилешки бут": "chicken thigh", "пилешки крилца": "chicken wings",
  "свинско": "pork", "свинско месо": "pork", "свински": "pork",
  "телешко": "beef", "телешко месо": "beef", "говеждо": "beef",
  "агнешко": "lamb", "агнешко месо": "lamb",
  "кайма": "ground meat", "свинска кайма": "ground pork", "телешка кайма": "ground beef",
  "шунка": "ham", "бекон": "bacon", "салам": "salami", "наденица": "sausage",
  "кюфте": "meatball", "кюфтета": "meatball", "кебапче": "kebab",
  "суджук": "sausage spicy", "луканка": "dry sausage",
  "пуйка": "turkey", "пуешко": "turkey", "патица": "duck", "заек": "rabbit",

  // Риба / Fish & Seafood
  "риба": "fish", "сьомга": "salmon", "тон": "tuna", "скумрия": "mackerel",
  "пъстърва": "trout", "треска": "cod", "ципура": "sea bream", "лаврак": "sea bass",
  "сардина": "sardine", "сардини": "sardine", "скариди": "shrimp", "калмар": "squid",
  "миди": "mussels", "октопод": "octopus", "хайвер": "caviar",

  // Млечни / Dairy
  "мляко": "milk", "прясно мляко": "fresh milk", "кисело мляко": "yogurt",
  "йогурт": "yogurt", "сирене": "cheese", "бяло сирене": "feta cheese",
  "кашкавал": "yellow cheese", "извара": "cottage cheese",
  "масло": "butter", "краве масло": "butter", "сметана": "cream",
  "крема сирене": "cream cheese", "моцарела": "mozzarella",
  "пармезан": "parmesan", "рикота": "ricotta",

  // Яйца / Eggs
  "яйце": "egg", "яйца": "egg", "варено яйце": "boiled egg",
  "пържено яйце": "fried egg", "омлет": "omelette",

  // Зърнени / Grains & Cereals
  "хляб": "bread", "бял хляб": "white bread", "пълнозърнест хляб": "whole wheat bread",
  "ръжен хляб": "rye bread", "ориз": "rice", "бял ориз": "white rice",
  "кафяв ориз": "brown rice", "паста": "pasta", "макарони": "macaroni",
  "спагети": "spaghetti", "овесени ядки": "oats", "овесена каша": "oatmeal",
  "мюсли": "muesli", "корнфлейкс": "cornflakes", "елда": "buckwheat",
  "киноа": "quinoa", "кускус": "couscous", "булгур": "bulgur",
  "лимец": "spelt", "просо": "millet",

  // Бобови / Legumes
  "леща": "lentil", "леща": "lentil", "боб": "beans", "бял боб": "white beans",
  "нахут": "chickpeas", "соя": "soy", "соеви зърна": "soybeans",
  "фасул": "beans", "червен фасул": "kidney beans",

  // Ядки / Nuts & Seeds
  "бадем": "almond", "бадеми": "almond", "орех": "walnut", "орехи": "walnut",
  "фъстък": "peanut", "фъстъци": "peanut", "кашу": "cashew",
  "лешник": "hazelnut", "лешници": "hazelnut",
  "слънчогледови семки": "sunflower seeds", "тиквени семки": "pumpkin seeds",
  "ленено семе": "flaxseed", "чия": "chia seeds", "сусам": "sesame",
  "фъстъчено масло": "peanut butter",

  // Масла / Oils
  "зехтин": "olive oil", "слънчогледово масло": "sunflower oil",
  "кокосово масло": "coconut oil", "палмово масло": "palm oil",

  // Сладки и закуски / Sweets & Snacks
  "шоколад": "chocolate", "бисквити": "cookies", "бисквита": "cookie",
  "торта": "cake", "сладолед": "ice cream", "мед": "honey",
  "захар": "sugar", "конфитюр": "jam", "мармалад": "marmalade",
  "вафла": "waffle", "вафли": "waffle", "кроасан": "croissant",
  "чипс": "chips", "пуканки": "popcorn", "крекери": "crackers",

  // Напитки / Beverages
  "вода": "water", "чай": "tea", "кафе": "coffee", "сок": "juice",
  "портокалов сок": "orange juice", "ябълков сок": "apple juice",
  "бира": "beer", "вино": "wine", "айран": "ayran",

  // Готови ястия / Dishes
  "супа": "soup", "пилешка супа": "chicken soup", "зеленчукова супа": "vegetable soup",
  "чорба": "soup", "боб чорба": "bean soup", "шкембе чорба": "tripe soup",
  "баница": "pastry cheese", "пица": "pizza", "бургер": "burger",
  "сандвич": "sandwich", "палачинка": "pancake", "палачинки": "pancake",
  "мусака": "moussaka", "гювеч": "stew", "яхния": "stew",
  "шопска салата": "shopska salad tomato cucumber cheese",
  "таратор": "cold yogurt soup cucumber",
  "пържени картофи": "french fries", "пържоли": "steak",
  "кюфтета на скара": "grilled meatballs",
};

// Try to translate a Bulgarian query to English
export function translateFoodQuery(query) {
  const lower = query.toLowerCase().trim();
  
  // Direct match
  if (bgToEnFoodMap[lower]) {
    return bgToEnFoodMap[lower];
  }
  
  // Try each word
  const words = lower.split(/\s+/);
  const translated = words.map(w => bgToEnFoodMap[w] || w);
  const translatedStr = translated.join(" ");
  
  // If any word was translated, use translation
  if (translatedStr !== lower) {
    return translatedStr;
  }
  
  // Check if query contains any Bulgarian key as substring
  for (const [bg, en] of Object.entries(bgToEnFoodMap)) {
    if (lower.includes(bg)) {
      return en;
    }
  }
  
  // Return original if no translation found (assume English)
  return query;
}

// Check if a string contains Cyrillic characters
export function isCyrillic(text) {
  return /[а-яА-ЯёЁ]/.test(text);
}
